module.exports = __webpack_public_path__ + "img/france-digestive-diseases-male.40f416b0.png";